// src/components/perfil/components/ChangePasswordForm.js

import React, { useState } from 'react';

function ChangePasswordForm({ setPassword }) {
  const [passwordData, setPasswordData] = useState({
    atual: '',
    password: '',
    confirmar: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const { atual, password, confirmar } = passwordData;
    setPassword(atual, password, confirmar);
  };

  return (
    <div className="tab-pane fade" id="segunda-aba" role="tabpanel">
      {/* Senha Atual */}
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label className="required">Senha Atual</label>
            <input
              type="password"
              className="form-control"
              name="atual"
              id="atual"
              placeholder="******"
              value={passwordData.atual}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      </div>

      {/* Nova Senha */}
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label className="required">Nova Senha</label>
            <input
              type="password"
              className="form-control"
              name="password"
              id="password"
              placeholder="******"
              value={passwordData.password}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      </div>

      {/* Confirmar Nova Senha */}
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label className="required">Confirmar Nova Senha</label>
            <input
              type="password"
              className="form-control"
              name="confirmar"
              id="confirmar"
              placeholder="******"
              value={passwordData.confirmar}
              onChange={handleChange}
              required
            />
          </div>
        </div>
      </div>

      {/* Botão de Atualização */}
      <div className="row">
        <div className="col-md-12 text-center">
          <button className="btn btn-success" id="atualizar" onClick={handleSubmit}>
            Atualizar Senha
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordForm;
